import { Provider } from "./provider/Provider";
import axios from "axios";
import store from "@/store";

const MediaService = {
  mediaList: ({ mediaFormat, start, limit }) => {
    return Provider({
      mediaFormat,
      mediaTime: "",
      mediaStart: start,
      mediaLimit: limit,
      listType: "desc",
      methodName: "Api/Media/MediaList",
    });
  },
  acceptFiles: () => {
    return Provider({
      methodName: "Api/Media/AcceptFiles",
    });
  },
  acceptFilesList: () => {
    return Provider({
      methodName: "Api/Media/AcceptFilesList",
    });
  },
  acceptBaseImages: () => {
    return Provider({
      methodName: "Api/Media/AcceptBaseImages",
    });
  },
  mediaListTypes: () => {
    return Provider({
      methodName: "Api/Media/MediaListTypes",
    });
  },
  mediaFormats: () => {
    return Provider({
      methodName: "Api/Media/MediaFormats",
    });
  },
  removeFiles: (fileNames) => {
    return Provider({
      fileNames,
      methodName: "Api/Media/Remove",
    });
  },
  searchMedia: ({ search }) => {
    return Provider({
      listType: "desc",
      search,
      methodName: "Api/Media/SearchMedia",
    });
  },
  // uploadImage: (files) => {
    
  // },
  renew: ({ file, fileName }) => {
    let formData = new FormData(),
      token = store.state.User.UserLogin.token,
      methodName = "Api/Media/Renew";

    formData.append(`renewFile`, file);
    formData.append(`data[fileName]`, fileName);
    formData.append("data[methodName]", methodName);
    formData.append("data[token]", token);

    return axios({
      url: process.env.VUE_APP_API_URL,
      data: formData,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      auth: {
        username: process.env.VUE_APP_API_USER,
        password: process.env.VUE_APP_API_PASS,
      },
    });
  },
};

export default MediaService;
